<script>
import commonApi from '@/api/common.api.js';
import yjyAPI from '@/api/yjy.api.js';
import Base from './gpt-chatbox-yjy-base.vue';
export default {
    name: 'gpt-chatbox-yjy-fire-smoke',
    extends: Base,
    methods: {
        /**
         * 上传
         */
        async send () {
            if (this.prompt.trim() === '' || !this.fileUrl) {
                this.$message.error('请输入内容和上传图片后再发送');
                return;
            }
            try {
                let url = this.fileUrl;
                let base64String = this.fileBase64;
                let caption = this.prompt;
                let urlA = url.substring(url.indexOf('smoke_fire'));
                let ret = await yjyAPI.img2text_glip(urlA, base64String, caption, 'fire_smoke');

                // 截取URL，去掉前面的域名
                if (url.indexOf('/llm/') >= 0) {
                    url = '/llm-files/' + url.substring(url.indexOf('/llm/') + 5);
                }

                let input = `${this.prompt}\n![图片](${url})`;
                let title = caption;

                let answer = ret.content || '未识别数据';
                let data = ret.data;
                if (data) {
                    // 处理返回图片
                    let fileName = Date.now() + '-' + caption + '.jpg';
                    let payload = {
                        'fileContent': data,
                        'fileContentType': '',
                        'fileName': fileName
                    };
                    let retUrl = await commonApi.upload(payload);
                    // 截取URL，去掉前面的域名
                    if (retUrl.indexOf('/llm/') >= 0) {
                        retUrl = '/llm-files/' + retUrl.substring(retUrl.indexOf('/llm/') + 5);
                    }
                    answer += `\n![图片](${retUrl})`;
                }
                this.$emit('askAnswer', { title, input, answer, nospeech: true });
                this.oneUpload = null;
                this.prompt = '';
                this.fileUrl = '';
            } catch (err) {
                console.error(err);
            }
        }
    }
};
</script>

<style scoped lang="scss">
@import './gpt-chatbox-yjy-base.scss';
</style>
